import request from '@/lib/api'

const _BASE = "/api";


// 配额审批列表
export function getQuotaList(params) {
  return request({
    url: `${_BASE}/tPmcApplication/limit`,
    method: 'get',
    params
  })
}

//获取配额详情
export function getQuotaDetail(id) {
  return request({
    url: `${_BASE}/tPmcApplication/limit/${id}`,
    method: 'get',
  })
}

// 审核通过
export function checkPass(id) {
  return request({
    url: `${_BASE}/tPmcApplication/limit/${id}`,
    method: 'put',
  })
}
// 驳回申请
export function chackReturn(params) {
  return request({
    url: `${_BASE}/tPmcApplication/limit`,
    method: 'put',
    params
  })
}